/*
 * VISIONE INCISA — Bundle segnalibri
 * Mantiene sincronizzata la grafica personalizzata con le vere varianti
 * Shopify e aggiunge le scelte dei personaggi all'ordine.
 */
class ViBookendBundles extends HTMLElement {
  connectedCallback() {
    this.formId = this.dataset.formId;
    this.bundleInputs = Array.from(this.querySelectorAll('input[data-character-count]'));
    this.characterFields = Array.from(this.querySelectorAll('[data-character-field]'));
    this.characterSelects = this.characterFields.map((field) => field.querySelector('select'));
    this.allCharactersInput = this.querySelector('[data-all-characters]');
    this.allMessage = this.querySelector('[data-all-message]');
    this.error = this.querySelector('[data-error]');

    this.bundleInputs.forEach((input) => input.addEventListener('change', () => this.handleBundleChange(input)));
    this.characterSelects.forEach((select) =>
      select?.addEventListener('change', () => this.handleCharacterChange(select))
    );

    this.updateCharacterFields(this.querySelector('input[data-character-count]:checked'));
    this.syncVariantId();

    // Il blocco bundle viene stampato prima del modulo di acquisto.
    // Attende un frame per collegarsi al form quando tutto il DOM è disponibile.
    requestAnimationFrame(() => {
      const form = this.getProductForm();
      form?.addEventListener('submit', this.validateCharacters, true);
      this.syncVariantId();
    });
  }

  disconnectedCallback() {
    const form = this.getProductForm();
    form?.removeEventListener('submit', this.validateCharacters, true);
  }

  validateCharacters = (event) => {
    this.syncVariantId();

    const activeSelects = this.characterSelects.filter((select) => select && !select.disabled);
    const values = activeSelects.map((select) => select.value).filter(Boolean);

    if (activeSelects.some((select) => !select.value)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      this.showError('Scegli tutti i segnalibri prima di aggiungere il bundle al carrello.');
      activeSelects.find((select) => !select.value)?.focus();
      return;
    }

    if (new Set(values).size !== values.length) {
      event.preventDefault();
      event.stopImmediatePropagation();
      this.showError('Scegli modelli diversi per questo bundle.');
      return;
    }

    this.showError('');
  };

  handleBundleChange(input) {
    this.updateCharacterFields(input);
    this.syncVariantId(input.value);

    const picker = this.closest('.product-details')?.querySelector('variant-picker');
    const originalInput = Array.from(picker?.querySelectorAll('input[data-option-name]') || []).find(
      (candidate) => candidate.value === input.dataset.variantTitle
    );

    if (originalInput && !originalInput.checked) originalInput.click();
  }

  getProductForm() {
    return (
      document.getElementById(this.formId) ||
      this.closest('.product-details')?.querySelector('form[action*="/cart/add"]') ||
      null
    );
  }

  syncVariantId(forcedVariantId) {
    const selectedBundle = this.querySelector('input[data-character-count]:checked');
    const variantId = forcedVariantId || selectedBundle?.value;
    const form = this.getProductForm();
    const variantInput = form?.querySelector('input[name="id"]');

    if (variantInput && variantId) {
      variantInput.value = variantId;
      variantInput.setAttribute('value', variantId);
    }
  }

  updateCharacterFields(input) {
    if (!input) return;

    const isCompleteCollection = input.dataset.characterCount === 'all';
    const requestedCount = isCompleteCollection ? 0 : Number(input.dataset.characterCount || 1);

    this.characterFields.forEach((field, index) => {
      const select = this.characterSelects[index];
      const isActive = index < requestedCount;

      field.hidden = !isActive;
      if (!select) return;
      select.disabled = !isActive;
      select.required = isActive;
      if (!isActive) select.value = '';
    });

    if (this.allCharactersInput) this.allCharactersInput.disabled = !isCompleteCollection;
    if (this.allMessage) this.allMessage.hidden = !isCompleteCollection;
    this.querySelector('.vi-bookend-characters__heading')?.toggleAttribute('hidden', isCompleteCollection);
    this.querySelector('.vi-bookend-characters__grid')?.toggleAttribute('hidden', isCompleteCollection);

    this.showError('');
    this.refreshDisabledOptions();
  }

  handleCharacterChange(select) {
    this.showError('');
    this.refreshDisabledOptions();
    this.showCharacterImage(select.value);
  }

  showCharacterImage(characterName) {
    if (!characterName) return;

    const gallery = this.closest('.shopify-section')?.querySelector('media-gallery');
    const slides = Array.from(gallery?.querySelectorAll('slideshow-slide') || []);
    const normalizedName = characterName.trim().toLocaleLowerCase('it');
    const slideIndex = slides.findIndex((slide) => {
      const imageAlt = slide.querySelector('.product-media__image')?.getAttribute('alt') || '';
      return imageAlt.trim().toLocaleLowerCase('it') === normalizedName;
    });

    if (slideIndex >= 0 && gallery?.slideshow?.select) {
      gallery.slideshow.select(slideIndex, undefined, { animate: true });
    }
  }

  refreshDisabledOptions() {
    const activeSelects = this.characterSelects.filter((select) => select && !select.disabled);
    const selectedValues = activeSelects.map((select) => select.value).filter(Boolean);

    activeSelects.forEach((select) => {
      Array.from(select.options).forEach((option) => {
        option.disabled = Boolean(option.value && option.value !== select.value && selectedValues.includes(option.value));
      });
    });
  }

  showError(message) {
    if (!this.error) return;
    this.error.textContent = message;
    this.error.hidden = !message;
  }
}

if (!customElements.get('vi-bookend-bundles')) {
  customElements.define('vi-bookend-bundles', ViBookendBundles);
}
